<template>
  <div id="ImpersonationView">
    <v-speed-dial
      v-model="fab"
      direction="bottom"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="red"
          elevation="3"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-account-supervisor
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="agency-color-compliment"
        title="Information sheet"
        @click="sheet = !sheet"
      >
        <v-icon>mdi-bug</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="agency-color-compliment"
        :href="exit"
        title="Exit impersonation"
      >
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-bottom-sheet
      v-model="sheet"
      attach="#AgencyView"
    >
      <v-sheet
        class="text-center"
      >
        <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet = !sheet"
        >
          close
        </v-btn>
        <div class="py-3">
          You are impersonating <span>{{ user.first_name }}</span> <span>{{ user.last_name }}</span>
          <p>Email: {{ user.email }}</p>
        </div>
        <div
          v-if="$route.name === 'agency.candidates.edit' || $route.name === 'agency.candidates.show'"
          class="text-left"
        >
          <hr>
          <span class="pa-4">Contextual Information</span>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>
                    Name
                  </th>
                  <th>
                    V1 Id
                  </th>
                  <th>
                    V1 Candidate to Agency Id
                  </th>
                  <th>
                    Synced
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{ candidate.full_name }}
                  </td>
                  <td>
                    {{ candidate.v1_id }}
                  </td>
                  <td>
                    {{ candidate.candidate_to_agency_id }}
                  </td>
                  <td>
                    {{ candidate.is_synced }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  name: 'ImpersonationView',
  props: {
    exit: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    fab: false,
    sheet: false
  }),
  computed: {
    candidate () {
      return this.$store.state.candidates.candidate
    }
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang='scss'>
#ImpersonationView {
    display: flex;
    position:fixed;
    top: 0;
    width:100%;
    justify-content: right;
    z-index: 999;
    border-top: 5px solid #f44336;
    padding: 0 25px;
    height: 5px;

    .v-speed-dial__list {
      top: 50px;
    }
}
</style>
